const validate = values => {
    const errors = {periodo: ''};
    if (!values.periodo) {
        errors.periodo = 'Seleccione un periodo';
    }
    return errors;
};

export default validate;


// WEBPACK FOOTER //
// ./src/components/pages/tdos/validate.ts